module.exports = __webpack_public_path__ + "static/media/login-content.88972521.png";